var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLabsinline = function SvgLabsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 22,
    fill: "#FFBF00",
    rx: 2,
    transform: "rotate(-90 2 22)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 6a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm5.127 6V9H9.87v3l-2.602 3.668a1.426 1.426 0 0 0-.08 1.538c.136.24.338.44.586.58.247.14.53.213.819.214h6.81c.29 0 .573-.074.821-.213.248-.14.45-.34.587-.58a1.425 1.425 0 0 0-.08-1.539L14.128 12",
    clipRule: "evenodd"
  })));
};
export default SvgLabsinline;